import { useMemo } from 'react';

/**
 * 페이지네이션 로직을 처리하는 커스텀 훅
 * @param {Array} items - 페이지네이션할 전체 아이템 배열
 * @param {number} currentPage - 현재 페이지 번호
 * @param {number} pageSize - 페이지당 아이템 개수
 * @returns {Object} 페이지네이션 관련 데이터
 */
export const usePagination = (items, currentPage, pageSize = 6) => {
  // 전체 페이지 수 계산
  const totalPages = useMemo(
    () => Math.max(1, Math.ceil(items.length / pageSize)),
    [items.length, pageSize]
  );

  // 현재 페이지를 전체 페이지 범위 내로 제한
  const validCurrentPage = useMemo(
    () => Math.min(currentPage, totalPages),
    [currentPage, totalPages]
  );

  // 현재 페이지에 표시할 아이템들
  const paginatedItems = useMemo(() => {
    const startIndex = (validCurrentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return items.slice(startIndex, endIndex);
  }, [items, validCurrentPage, pageSize]);

  return {
    paginatedItems,
    totalPages,
    currentPage: validCurrentPage,
  };
};
